import IFrameCode from '@/components/content-types/iFrameCode';

const IFrameCodeBlock = ({ node }) => {
    const { frameCode, thumbnail, useFrame, buttonLabel, trackConversion, conversionKey } =
        node?.attrs?.data ?? {};

    return (
        <IFrameCode
            frameCode={frameCode}
            thumbnail={thumbnail}
            useFrame={useFrame === true || useFrame === 'true'}
            buttonLabel={buttonLabel}
            trackConversion={trackConversion === true || trackConversion === 'true'}
            conversionKey={conversionKey}
            maxHeight={370}
        />
    );
};

export default IFrameCodeBlock;
